var SpriteSymbol = require("../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "add",
  "use": "add-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"add\">\r\n  <path d=\"M6.38462 0.5V5.88462H1V9.11538H6.38462V14.5H9.61538V9.11538H15V5.88462H9.61538V0.5H6.38462Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol